const renderSettings = ({ block, setBlock }: any) => {
    return <></>;
};

export default renderSettings;
